export default __webpack_public_path__ + "static/media/infoIcon.47aa3402.svg";